import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {updateObject} from '@/store/utils'
import {HeaderState} from './types'

const initState: HeaderState = {
  height: 78,
  active: false,
  backwards: null,
  background: 'white',
  title: ' ',
  action: null,
}
const module: ModuleFc<HeaderState> = () => {
  return {
    namespaced: true,
    state: cloneDeep(initState),

    mutations: {
      update(state, payload) {
        updateObject(state, payload, ['backwards', 'title', 'action', 'background'])
      },
      clear(state) {
        updateObject(state, initState)
      },
      updateBackground(state, background: string) {
        updateObject(state, {background}, ['background'])
      },
      active(state, payload: boolean) {
        state.active = payload
      },
    },
  }
}

export default module
